<template>
  <div>
    <component :is="componentName"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ContactsCoAndRegions from "@/pages/Contacts/ContactsCoAndRegions";
import ContactsOrganization from "@/pages/Contacts/ContactsOrganization";
import ContactsExpert from "@/pages/Experts/ExpertProtocols.vue";

export default {
  name: "ContactLayout",
  components: {
    ContactsCoAndRegions,
    ContactsOrganization,
    ContactsExpert
  },
  data() {
    return {
      customConfig: {
        width: 500,
        title: "Уведомление пользователей",
        message:
          "Уважаемые коллеги! В период с 18:00 13 ноября до 06:00 14 ноября 2023 года по московскому времени запланировано проведение профилактических технических работ на серверном оборудовании. В указанный период возможны перебои в работе личных кабинетов. Приносим извинения за предоставленные неудобства!",
        btnText: "ОК",
      },
    };
  },
  computed: {
    ...mapGetters('keycloak', {currentRole: 'currentRole',}),
    componentName() {
      console.log(this.currentRole);
      switch (this.currentRole) {
        case 'ORGANIZATION_ROLE':
          return 'ContactsOrganization'
        case 'FOUNDER_ROLE':
          return 'ContactsCoAndRegions'
        case 'REGION_ROLE':
          return 'ContactsCoAndRegions'
        case 'CO_ROLE':
          return 'ContactsCoAndRegions'
        case 'EXPERT_KCP_ROLE':
          return 'ContactsExpert'
        default:
          return 'ContactsCoAndRegions'
      }
    }
  },
}
</script>

<style scoped>

</style>